import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CarlineLayout from '../components/CarlineLayout';

const Index = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // If accessing /post/:id, redirect to /?post=:id for regular users
    if (id) {
      navigate(`/?post=${id}`, { replace: true });
    }
  }, [id, navigate]);

  return <CarlineLayout />;
};

export default Index;
